<template>
  <div class="d-flex flex-column">
    <div class="sub-title">MeubelPanelen</div>

    <table class="panel-rows furniturepanel-rows">
      <thead>
        <tr>
          <th class="index">&nbsp;</th>
          <th class="length">&nbsp;</th>
          <th class="width">&nbsp;</th>
          <th class="amount">&nbsp;</th>
          <th class="priceinfo"> </th>
          <th class="description" colspan="2">
            Kantafwerking
            <font-awesome-icon id="finish-info-icon" class="font-awesome-icon finish-info" icon="info-circle"/>
            <b-tooltip target="finish-info-icon" variant="secondary" placement="top"><img src="images/kv.png"/></b-tooltip>
          </th>
          <th class="actions">&nbsp;</th>
        </tr>
        <tr>
          <th class="index">&nbsp;</th>
          <th class="length"> </th>
          <th class="width"> </th>
          <th class="amount">&nbsp;</th>
          <th class="priceinfo"> </th>
          <th class="description brackets" colspan="2">
            <div class="brackettop left"></div>
            <div class="bracketside left"></div>
            <div class="bracketside right"></div>
            <div class="brackettop right"></div>
            Lengte
          </th>
          <th class="actions">&nbsp;</th>
        </tr>
        <tr>
          <th class="index">&nbsp;</th>
          <th class="length">Lengte</th>
          <th class="width">Breedte</th>
          <th class="amount">Aantal</th>
          <th class="priceinfo">Prijs per paneel</th>
          <th class="checkbox l1">L1</th>
          <th class="checkbox l2">L2</th>
          <th class="actions">&nbsp;</th>
        </tr>
      </thead>

      <tbody class="panel-rows-body">
        <tr class="spacer-row"><td colspan="8"></td></tr>
        <app-furniturepanel-row
          v-for="panel in panels"
          :panel="panel"
          ref="panel"
          :key="panel.id"
        />

        <tr class="disabled-panel-row" @click="addRow">
          <td class="index">
            {{ panels.length + 1 }}
          </td>
          <td class="length">
            <input type="number" disabled class="form-control disabled" min="0" placeholder="mm">
          </td>
          <td class="width">
            <input type="number" disabled class="form-control disabled" min="0" placeholder="mm">
          </td>
          <td class="amount">
            <input type="number" disabled class="form-control disabled" min="0" placeholder="st">
          </td>
          <td class="priceinfo">
            <input type="number" disabled class="form-control disabled" min="0">
          </td>
          <td class="checkbox l1">
            <input disabled type="checkbox" class="checkbox-side"/>
            <label></label>
          </td>
          <td class="checkbox l2">
            <input disabled type="checkbox" class="checkbox-side"/>
            <label></label>
          </td>
          <td class="actions">
            &nbsp;
          </td>
        </tr>
        <tr class="spacer-row"><td colspan="8"></td></tr>
      </tbody>
    </table>

  </div>
</template>

<script>
  import FurniturePanelRow from '@/components/Tool/Panels/FurniturePanelRow.vue'

  export default {
    data() {
      return {}
    },
    components: {
      'app-furniturepanel-row': FurniturePanelRow
    },
    computed: {
      panels() {
        if (this.$store.getters.panels) {
          this.$store.getters.panels.map(panel => {
            panel.l1 = true
            panel.l2 = true
            return panel
          })
        }
        console.log('panels', this.$store.getters.panels)
        return !this.$store.getters.panels ? [] : this.$store.getters.panels
      },
      product() {
        return this.$store.getters.materialProduct
      },
      side1() {
        return this.$store.getters.materialSide1
      },
      hasGrain() {
        let top = !this.side1 ? this.product : this.side1
        return top && top.grain && top.grain !== 'Geen' ? top.grain.toLowerCase() : false
      },
      products() {
        if (this.$store.getters.filterThird) {
          let filterFirst = this.$store.getters.filterFirst
          let filterSecond = this.$store.getters.filterSecond
          let filterThird = this.$store.getters.filterThird !== 'geen' ? this.$store.getters.filterThird : ''

          let products = this.products.filter((product) => (product.deliveryprogram === filterDeliveryProgram && product.filter_1 === filterFirst && product.filter_2 === filterSecond && product.filter_3 === filterThird))

          // Sort by width
          let filters = [...new Set(products.sort((a, b) => (parseInt(a.width) > parseInt(b.width)) ? 1 : ((parseInt(b.width) > parseInt(a.width)) ? -1 : 0)))]

          return filters
        }

        return []
      }
    },
    methods: {
      addRow() {
        let id = this.panels.length + 1

        this.panels.push({ id: id, length: null, width: null, amount: null, l1: true, l2: true, b1: false, b2: false, reference: null, valid: null })
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
